import { useEffect } from "react";

export default function GDriveCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    if (window.opener) {
      window.opener.postMessage({ type: "gdrive-callback", code }, window.location.origin);
      setTimeout(() => window.close(), 500);
    }
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="text-center">
        <p className="text-lg text-foreground mb-2">Connexion Google Drive en cours...</p>
        <p className="text-sm text-muted-foreground">Cette fenêtre va se fermer automatiquement.</p>
      </div>
    </div>
  );
}